// CSP nonce propagation for jQuery-evaluated server-generated JavaScript (SJR).
//
// jquery-ujs remote responses, $.ajax({ dataType: "script" }) and $.getScript all
// run their response by injecting an inline <script> via jQuery's DOMEval. The
// nonce-based script-src (MAKE-4214) has no 'unsafe-inline', so those injected
// scripts are blocked. jQuery.globalEval can carry a nonce onto that <script>
// (it forwards `options.nonce` to DOMEval), so we stamp it with the page's CSP
// nonce — allowing our own first-party SJR to run.
//
// This does NOT weaken the protection that matters: a <script> injected via HTML
// (the classic XSS vector) still has no nonce and stays blocked. Only code routed
// through jQuery's own eval path is trusted, and 'unsafe-eval' is already allowed,
// so this adds no capability an attacker with a JS primitive didn't already have.
const nonceMeta = document.querySelector('meta[name="csp-nonce"]')
const cspNonce = nonceMeta && nonceMeta.getAttribute("content")

if (cspNonce && window.jQuery && typeof window.jQuery.globalEval === "function") {
  const originalGlobalEval = window.jQuery.globalEval
  window.jQuery.globalEval = function (code, options, doc) {
    options = options || {}
    if (options.nonce == null) options.nonce = cspNonce
    return originalGlobalEval.call(this, code, options, doc)
  }
}
